import React from 'react';
import { Box, BoxExtendedProps, CheckFilledIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

const VerifyBlock: React.FC<BoxExtendedProps> = ({ children, ...props }) => {
  return (
    <Box
      direction="row"
      pad={{ vertical: 'spacing8', horizontal: 'spacing12' }}
      round="snackbarRound"
      align="center"
      background="success"
      {...props}
    >
      <Box margin={{ left: 'spacing4', right: 'spacing12' }}>
        <CheckFilledIcon color={theme.colors.textOnColor} />
      </Box>
      <Box justify="center" fill>
        {children}
      </Box>
    </Box>
  );
};

export default VerifyBlock;
